export default "__VITE_ASSET__BhBAusR3__"